import React from 'react';
import './AboutCon.css';
import Nav from '../Nav';
import Navbar from '../Navbar';
import confImage from '../assets/kippra.jpg';
import Footer from '../Footer/Footer';
import GOK from '../assets/gok.png';
import VISION from '../assets/kenyavision.jpeg'

const AboutCon = () => {

  
  return (
    <div>
      <Nav/>
      <Navbar />

      <div>
      <h1 className='head'>KIPPRA CONFERENCE</h1>
      </div>
      <div className="container">
        <img src={confImage} alt="description" className="image" />
        <div className="description">
          <p className='desp'>The Kenya Institute for Public Policy Research and Analysis (KIPPRA) is organizing the 6th KIPPRA Annual Regional Conference themed “Accelerating Economic Growth and Development for ASALs in Kenya.”</p>
          <p className='conf'>The conference brings together state and non-state actors to exchange views on building strong foundations to propel sustainable economic transformation in Kenya. This is in fulfilment of the Institute’s mandate to provide a platform for policy dialogue among
stakeholders in the public policy space to explore and discuss potential areas and opportunities to exploit in forging a common front to accelerate achievement of a sustainable inclusive development. In addition, the conference will host a youth event that brings together university students to focus on their transition to the world of work.</p>
        </div>
      </div>
      <div>
        <p className='despar'>
        The conference is planned for 21st to 23rd June 2023 at Pwani University in Kilifi County. The conference is hosted by KIPPRA in collaboration with other key stakeholders, including government ministries, departments, and agencies. The conference will also bring together delegates comprising officials from national and county governments, representatives of national authorities from the regional economic blocs, regional think tanks, as well as development partners, civil society, persons with disability and other special interest groups.
        </p>
        <p className='despar'>
        Arid and Semi-Arid Lands (ASALs) make up to 89% of the Country with approximately 38% of Kenya’s Population, covering 29 counties  and a population of about 16 million people. The ASALs have unlimited economic development potential which includes a home to 90 percent of wildlife and 75 percent livestock; have the highest potential for blue economy within Lake Turkana and the coastline of Indian Ocean; and approximately covers 95 per cent of cross-country borders. The great economic potential if unlocked, can change millions of lives, transform communities and secure prosperity for many generations.
        </p>
        <p className='despar'>
        The defining feature of the ASALs is their aridity and high temperatures throughout the year, with high evapotranspiration rates. Annual rainfall in arid areas ranges between 150mm and 550mm per year, and in semi-arid areas between 550mm and 850mm per year. Due to various factors, social development indicators in ASALs are low compared to the rest of the Country. ASALs communities have characteristically low capacity to withstand social, economic, and environmental shocks arising from droughts, conflicts, and climate change.
        </p>
        <p className='despar'>
        A large proportion of the population in the ASALs lack the basic foundations of growth and development, such as access to education and therefore are home to the Country’s poorest and most vulnerable populations, whose resilience is increasingly depleted and require regular humanitarian assistance. Geographical conditions, cultural and social norms, distance to schools and communities’ perception of schooling play a significant role in access to education for children between 4-5 years in the ASALs. The nomadic lifestyle of communities in the ASALs is a hindrance to formal education and a key contributing factor to low enrolment rates and subsequent high dropout rates.
        </p>
        <p className='despar'>
        The 6th KIPPRA Annual Regional Conference is, therefore, organized to bring together state and non-state actors to discuss the opportunities, progresses made, challenges faced and the way forward in forging a common front to accelerate the economic growth and development for ASALS. This in fulfilment of the Institute’s role of providing a platform to promote the exchange of views among stakeholders in the public policy space.
        </p>
      </div>
      <div className='partners'>
        Our Partners 
      </div>
      <div className='imagepat'>
        <img style={{ marginLeft: "40px"}} src={GOK} alt="goverment of kenya" />
        <img  src={VISION} alt=" vision 2030" />
      </div>
      <div style={{marginTop: '30px'}}>
      <Footer />
      </div>
    </div>
  );
}

export default AboutCon;
